var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dropdown',[_c('div',{staticClass:"avatar",style:({
      0: 'background: #3473E6;',
      1: 'background: #5DD5C8;',
      2: 'background: #1B335D;'
    }[_vm.titleType])},[_vm._v(" "+_vm._s({ 0: String(_vm.userInfo.username).charAt(0), 1: '科', 2: '管' }[_vm.titleType])+" ")]),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.exit.apply(null, arguments)}}},[_vm._v("退出登录")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }